// src/components/TestimonialCard.js
import React, { useState } from 'react'; // 1. Import useState
import './TestimonialCard.css';

const TestimonialCard = ({ image, name, rating, quote }) => {
  // 2. Add state to track if the card is expanded or not
  const [isExpanded, setIsExpanded] = useState(false);

  // 3. A function to toggle the state
  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    // 4. Add a dynamic 'expanded' class to the main div
    <div className={`testimonial-card ${isExpanded ? 'expanded' : ''}`}>
      <img src={image} alt={`Testimonial from ${name}`} className="testimonial-photo" />
      <div className="testimonial-details">
        <div className="testimonial-header">
          <h4>{name}</h4>
          <div>
            <span className="testimonial-rating">{rating} ★</span>
          </div>
        </div>
        {/* The <p> tag will be controlled by the CSS */}
        <p>{quote}</p>
        
        {/* 5. Add the "Read More" / "Read Less" button */}
        <button onClick={toggleReadMore} className="read-more-btn">
          {isExpanded ? 'Read Less' : 'Read More'}
        </button>
      </div>
    </div>
  );
};

export default TestimonialCard;